import { gql } from '@apollo/client';
import { tilesetDataFragment } from 'api/fragments/workflows';

export const fetchGenAIJourneys = gql`
  query generateExampleJourneys($prompt: String!) {
    generateExampleJourneys(prompt: $prompt) {
      ...TilesetDataFragment
    }
  }
  ${tilesetDataFragment}
`;

export const fetchGenAITileset = gql`
  query generateTileset($prompt: String!) {
    generateTileset(prompt: $prompt) {
      ...TilesetDataFragment
    }
  }
  ${tilesetDataFragment}
`;
